import React from 'react'
import { SvgIcon } from '@material-ui/core'

const AvgIcon = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path d="M4.61538 11.0525C4.87028 11.0525 5.07692 11.2592 5.07692 11.514V19.3845C5.07692 19.6394 4.87028 19.846 4.61538 19.846C4.36048 19.846 4.15384 19.6394 4.15384 19.3845V11.514C4.15384 11.2592 4.36048 11.0525 4.61538 11.0525Z" />
      <path d="M19.3846 11.0525C19.6395 11.0525 19.8461 11.2592 19.8461 11.514V19.3845C19.8461 19.6394 19.6395 19.846 19.3846 19.846C19.1297 19.846 18.9231 19.6394 18.9231 19.3845V11.514C18.9231 11.2592 19.1297 11.0525 19.3846 11.0525Z" />
      <path d="M8.3077 5.80566C8.5626 5.80566 8.76924 6.0123 8.76924 6.2672V19.3847C8.76924 19.6395 8.5626 19.8462 8.3077 19.8462C8.0528 19.8462 7.84616 19.6395 7.84616 19.3847V6.2672C7.84616 6.0123 8.0528 5.80566 8.3077 5.80566Z" />
      <path d="M15.6923 5.80566C15.9472 5.80566 16.1539 6.0123 16.1539 6.2672V19.3847C16.1539 19.6395 15.9472 19.8462 15.6923 19.8462C15.4375 19.8462 15.2308 19.6395 15.2308 19.3847V6.2672C15.2308 6.0123 15.4375 5.80566 15.6923 5.80566Z" />
      <path d="M12 2.30762C12.2549 2.30762 12.4615 2.51426 12.4615 2.76916V19.3845C12.4615 19.6394 12.2549 19.8461 12 19.8461C11.7451 19.8461 11.5385 19.6394 11.5385 19.3845V2.76916C11.5385 2.51426 11.7451 2.30762 12 2.30762Z" />
    </SvgIcon>
  )
}

export default AvgIcon
